
<template>
    <div>
        <DefaultMenu>
            <template #title>
                Empresas Administradas
            </template>
 
            <b-button v-b-modal.createModalManagedCompany>
                Añadir empresa <b-icon icon="card-checklist" font-scale="1"></b-icon>
            </b-button>
        </DefaultMenu>
        
        <!-- Modal - Crear Empresa Administrada -->
        <b-modal
          id="createModalManagedCompany"
          title="Crear Empresa Administrada"
          hide-footer
          size="xl"
          centered
          scrollable
          header-bg-variant="dark"
          v-model="modalShowCrear"
        >
            <template #modal-header="{ close }">
                <!-- emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <!-- cuerpo -->
            <AlertDismiss ref="alertdismiss"></AlertDismiss>
            <ManagedCompaniesForm></ManagedCompaniesForm>
        </b-modal>

        <!-- Modal - Editar Empresa Administrada -->
        <b-modal
            id="editModalManagedCompany"
            title="Editar empresa administrada"
            hide-footer
            class=""
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
            v-model="modalShowEdit"
        >
          <template #modal-header="{ close }">
            <!-- emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-warning" @click="close()">
              Cerrar
            </b-button>
          </template>

          <!-- cuerpo -->
          <ShareholderEditForm :item="itemEditShareholder"></ShareholderEditForm>
        </b-modal>

        <!-- Modal - Historial de documentos -->
        <b-modal
            id="showModalManagedCompanyDocumentHistory"
            title="Historial de documentos"
            hide-footer
            size="lg"
            centered
            scrollable
            header-bg-variant="dark"
            v-model="modalShowDocumentHistory"
        >
          <template #modal-header="{ close }">
            <!-- emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-warning" @click="close()">
              Cerrar
            </b-button>
          </template>

          <div v-if="itemsHistoryDocument !== null">
            <DocumentHistoryTable
                :id="itemsHistoryDocument.id"
            ></DocumentHistoryTable>
          </div>
        </b-modal>

        <!-- Modal - Escritura de la sociedad -->
        <b-modal
            id="showModalManagedCompanyDocument"
            title="Escritura de la sociedad"
            hide-footer
            class=""
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
            v-model="modalShowDocument"
        >
          <template #modal-header="{ close }">
            <!-- emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-warning" @click="close()">
              Cerrar
            </b-button>
          </template>

          <DocumentPdf :pdf-url="itemDocumentURL"></DocumentPdf>
        </b-modal>

        <ShareholderAssignementRemove></ShareholderAssignementRemove>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import ManagedCompaniesForm from "@/components/ManagedCompanies/ManagedCompaniesMenu/Managed-companies-form.vue";
import ShareholderEditForm from "@/components/ManagedCompanies/ShareholderDetails/Shareholder-edit-company-form.vue";
import {EventNames} from "@/plugins/enums";
import DocumentPdf from "@/components/shared/Document-pdf.vue";
import DocumentHistoryTable from "@/components/ManagedCompanies/ManagedCompaniesMenu/Document-history-table.vue";
import ShareholderAssignementRemove from "@/components/ManagedCompanies/ManagedCompaniesMenu/Shareholder-assignement-remove.vue";
    
export default {
    name: 'ManagedCompaniesMenu',

    data() {
        return {
            modalShowCrear: false,
            modalShowEdit: false,
            modalShowDocumentHistory: false,
            modalShowDocument: false,
            itemEditShareholder: null,
            itemsHistoryDocument: null,
            itemDocumentURL: null,
            itemDeleteManagedCompany: null,
        }
    },

    mounted() {

        this.$eventBus.$on(EventNames.OpenModalShowManagedCompanyDocumentHistory, (data) => {
          this.itemsHistoryDocument = data
          this.modalShowDocumentHistory = true;
        });

        this.$eventBus.$on(EventNames.OpenModalShowManagedCompanyDocument, (data) => {
          this.itemDocumentURL = data;
          this.modalShowDocument = true;
        });

        this.$eventBus.$on(EventNames.OpenModalDeleteManagedCompany, (data) => {
          this.itemDeleteManagedCompany = data;
          this.modalShowDeleteManagedCompany = true;
        });
    },

    components: {
      DefaultMenu,
      DocumentHistoryTable,
      DocumentPdf,
      AlertDismiss,
      ManagedCompaniesForm,
      ShareholderAssignementRemove,
      ShareholderEditForm
    },
}
</script>
